
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/popover",
      function () {
        return require("private-next-pages/components/popover.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/popover"])
      });
    }
  